import * as ActionTypes from './types';

export function updateStoresCollection(payload) {
  return {
    type: ActionTypes.UPDATE_STORES_COLLECTION,
    payload: payload
  }
}

export function updateStoresCollectionSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_STORES_COLLECTION_SUCCESS,
    payload: payload
  }
}

export function updateStoresCollectionFailed(payload) {
  return {
    type: ActionTypes.UPDATE_STORES_COLLECTION_FAILED,
    payload: payload
  }
}
export function getCities(payload) {
    return {
        type: ActionTypes.GET_CITIES,
        payload: payload
    }
}

export function getCitiesSuccess(payload) {
  return {
    type: ActionTypes.GET_CITIES_SUCCESS,
    payload: payload
  }
}

export function getCitiesFailed(payload) {
  return {
    type: ActionTypes.GET_CITIES_FAILED,
    payload: payload
  }
}

export function changeStoresState(payload) {
    return {
        type: ActionTypes.CHANGE_STORES_STATE,
        payload: payload
    }
}

export function getStoresSuggestions(payload) {
    return {
        type: ActionTypes.GET_STORES_SUGGESTIONS,
        payload: payload
    }
}

export function getStoresSuggestionsSuccess(payload) {
  return {
    type: ActionTypes.GET_STORES_SUGGESTIONS_SUCCESS,
    payload: payload
  }
}

export function getStoresSuggestionsFailed(payload) {
  return {
    type: ActionTypes.GET_STORES_SUGGESTIONS_FAILED,
    payload: payload
  }
}

export function getStores(payload) {
  return {
    type: ActionTypes.GET_STORES,
    payload: payload
  }
}

export function getStoresSuccess(payload) {
  return {
    type: ActionTypes.GET_STORES_SUCCESS,
    payload: payload
  }
}

export function getStoresFailed(payload) {
  return {
    type: ActionTypes.GET_STORES_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/stores.js